import { useMemo } from "react";

export const useRequestMedicinesReceipt = (data: any, isNeedCooling: boolean) => {
    const hasCoolingMedicines = useMemo(() => data?.medicines?.some((item: any) => item.isNeedCooling && item.isAvailable), [data]);

    const availableMedicines = useMemo(() => data?.medicines?.filter((med: any) => med?.isAvailable), [data]);

    const shouldSplitCoolingMedicinesToSeparateReceipt =
        useMemo(() => {
            if (!data) return;
            return data?.splitCoolingMedicinesToSeparateReceipt && (availableMedicines?.some((item: any) => item.isNeedCooling) && availableMedicines?.some((item: any) => !item.isNeedCooling))
        }, [data, availableMedicines])

    const medicines = useMemo(() => {
        if (!availableMedicines) return;
        return availableMedicines?.filter(
            (med: any) => shouldSplitCoolingMedicinesToSeparateReceipt ? isNeedCooling ? med?.isNeedCooling : !med?.isNeedCooling : true)
    }, [availableMedicines, shouldSplitCoolingMedicinesToSeparateReceipt, isNeedCooling]);

    const showBillSections = useMemo(() => {
        if (!data) return;
        return !shouldSplitCoolingMedicinesToSeparateReceipt ||
            (shouldSplitCoolingMedicinesToSeparateReceipt && !isNeedCooling);
    }, [shouldSplitCoolingMedicinesToSeparateReceipt, isNeedCooling, data])

    return { hasCoolingMedicines, medicines, showBillSections, shouldSplitCoolingMedicinesToSeparateReceipt }
}